<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form @keyup.enter.native="getTableList" class="com-search-box" ref="form" :model="form" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="关键字 :" prop="name" placeholder="请输入">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="类型 :" prop="type">
              <el-select v-model="form.type" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加修复文物
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="collectionNo" label="藏品总登记号" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="collectionName" label="藏品名称" min-width="20%"></el-table-column>
          <el-table-column prop="collectionType" label="藏品类别" min-width="10%">
            <template slot-scope="scope">{{ scope.row.collectionType | filterType(that)}}</template>
          </el-table-column>
          <el-table-column prop="personInCharge" label="修复负责人" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="修复状态" min-width="6%">
            <template slot-scope="scope">{{ scope.row.status | filterStatus(that)}}</template>
          </el-table-column>
          <el-table-column prop="beginTime" label="开始修复时间" min-width="12%"></el-table-column>
          <el-table-column prop="endTime" label="修复完成时间" min-width="12%"></el-table-column>
          <el-table-column prop="createTime" label="添加时间" min-width="12%">
            <template slot-scope="scope">
              <span>{{$common.formatDateString(scope.row.createTime, 'yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="mark" label="备注" min-width="20%"></el-table-column> -->

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="15%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="fillFix(scope.row.id)">修复方案填写</a>
              <a class="m-btn mr-10" @click="handlerEdit(scope.row)">编辑</a>
              <a class="m-btn m-danger" @click="handlerDelete(scope.row.id)">删除</a>

              <!-- <a class="m-btn mr-10" @click="handleAdd('edit', scope.row.id)">预览</a> -->
              <!-- <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.id)">打印</a> -->
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
    <el-dialog title="添加修复文物" :visible.sync="dialogVisible" width="30%" @close="handleClose">
      <el-form class="g-form-grid" ref="addForm" :model="addForm" label-width="120px" :rules="rules">
        <el-form-item label="藏品名称 :" prop="collectionName">
          <el-input style="cursor: pointer;" readonly @focus="getCollectionList" v-model="addForm.collectionName" placeholder="请点击选择"></el-input>
        </el-form-item>

        <el-form-item label="藏品总登记号 :" prop="collectionNo">
          <el-input disabled v-model="addForm.collectionNo" placeholder="选择藏品自动获取藏品总登记号"></el-input>
        </el-form-item>

        <el-form-item label="藏品类别 :" prop="collectionType">
            <el-select v-model="addForm.collectionType" placeholder="请选择">
              <el-option v-for="item in typeList1" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="修复开始时间 :" prop="beginTime">
          <el-date-picker v-model="addForm.beginTime" :disabled="operation=='view'" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
        </el-form-item>

        <el-form-item label="修复完成时间 :" prop="endTime">
          <el-date-picker v-model="addForm.endTime" :disabled="operation=='view'" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
        </el-form-item>

        <el-form-item label="修复状态 :" prop="status">
          <el-select v-model="addForm.status" :disabled="operation=='view'" placeholder="请选择">
            <el-option v-for="item in statusList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="修复责任人 :" prop="personInCharge">
          <el-input v-model="addForm.personInCharge" :disabled="operation=='view'" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="备注 :" prop="mark">
          <el-input type="textarea" :disabled="operation=='view'" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容" v-model="addForm.mark"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer" v-if="operation !='view'">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="loadingSave" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加修复文物" :visible.sync="dialogVisible1" :width="'80%'">
      <!-- 表头搜索 -->
      <cmpSearchDict ref="cmpSearchDict" :pageType="`6`" @getParams="getHeadParams"></cmpSearchDict>

      <div class="com-list-content" style="margin-top: 0;padding-top:0">
        <div class="button">
          <el-row>
            <span style="font-size: 16px;color: #ff3333">提示：点击相应行数据选择</span>
          </el-row>
        </div>
        <!-- 表格 -->
        <div class="table mt-20">
          <el-table stripe :data="tableData1" v-loading="listLoading1" @row-click="rowClick" :row-key="(row)=>{ return row.collectId}" :row-style="(row)=>{let stylejson={cursor: 'pointer'}; return stylejson}">
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column prop="thumbPicture" label="藏品图片" min-width="8%">
              <template slot-scope="scope">
                <viewer :options="{ url: 'data-maxUrl' }">
                  <img class="g-pointer" :src="scope.row.thumbPicture || ''" :data-maxUrl="scope.row.thumbPicture" alt :onerror="defaultImg" style="width: 36px;height: 36px">
                </viewer>
              </template>
            </el-table-column>
            <el-table-column prop="collectName" label="藏品名称" min-width="8%" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="signCode" label="总登记号" min-width="8%" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="collectType" label="藏品分类" min-width="8%" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="collectLevel" label="级别" min-width="8%" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="typeCode" label="分类号" min-width="8%" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="collectYear" label="年代" min-width="8%" show-overflow-tooltip>
            </el-table-column>
          </el-table>

          <div class="pagination-container paging">
            <el-pagination :current-page="listQuery1.currentPage" :page-size="listQuery1.size" :total="total1" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange1" @current-change="handleCurrentChange1" />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cmpSearchDict from '@cmp/collect/search-dict'
export default {
  components: {
    cmpSearchDict
  },
  data() {
    return {
      that: this,
      defaultImg: this.$store.state.app.defaultImg,
      form: {
        name: '',
      },
      projectId: '',
      operation: '',
      addForm: {
        status: '',
        mark: '',
        personInCharge: '',
        beginTime: '',
        endTime: ''
      },
      loadingSave: false,
      rules: {
        projectName: [
          { required: true, message: '项目名称不能为空', trigger: 'blur' },
        ],

        beginTime: [
          { required: true, message: '修复开始时间不能为空', trigger: 'blur' },
        ],

        endTime: [
          { required: true, message: '修复完成时间不能为空', trigger: 'blur' },
        ],

        personInCharge: [
          { required: true, message: '修复责任人不能为空', trigger: 'blur' },
        ],

        status: [
          { required: true, message: '修复状态不能为空', trigger: 'blur' },
        ],

      },
      dialogVisible: false,
      dialogVisible1: false,
      typeList: [],
      typeList1: [],

      statusList: [],
      listLoading: true,
      listLoading1: true,

      listQuery: {
        currentPage: 1,
        size: 10
      },
      listQuery1: {
        currentPage: 1,
        size: 10
      },
      headParams: {},
      total: 0,
      total1: 0,
      tableData: [],
      tableData1: [],
    }
  },
  filters: {
    filterType(type, that) {
      let obj = that.typeList.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    },
    filterStatus(type, that) {
      let obj = that.statusList.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    }
  },
  methods: {
    // 初始化表格
    initList() {
      this.listLoading = true
      this.$api.repair.getRepairCulturalList({
        ...this.listQuery,
        projectId: this.projectId,
        ...this.form
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          let results = res.result
          this.tableData = results.records
          this.total = results.total
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.listLoading = false
      })
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['new_repair_status', 'new_repair_type']
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.typeList = firstArr.concat(state['new_repair_type'])
            this.typeList1 = state['new_repair_type']

            this.statusList = state['new_repair_status']
          } else {
            this.$message.error(res.message)
          }
        })
    },

    rowClick(row) {
      this.$emit('getRowData', row)
      this.dialogVisible1 = false
    },

    getCollectionList() {
      this.dialogVisible1 = true
      this.initCollectionList()
    },

    // 获取头部参数
    getHeadParams(params) {
      this.listQuery.currentPage = 1
      this.headParams = params
      this.initCollectionList()
    },

    // 编辑
    handlerEdit(obj) {
      this.addForm = JSON.parse(JSON.stringify(obj))
      this.dialogVisible = true
    },

    // 删除
    handlerDelete(id) {
      this.$common.confirm(
        {
          title: '是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.repair.deleteRepairCultural({ id: id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.initList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    handleClose() {
      this.addForm = {}
      this.$refs["addForm"].clearValidate()
      this.dialogVisible = false
    },

    // 提交
    handleSubmit() {
      this.$refs['addForm'].validate(vaild => {
        if (vaild) {
          let url = "addRepairCultural"
          if (this.addForm.id) {
            url = 'updateRepairCultural'
          }
          this.loadingSave = true
          this.addForm.projectId = this.projectId
          this.$api.repair[url](this.addForm).then(res => {
            this.loadingSave = false
            if (res.success) {
              if (this.addForm.id) {
                this.$message.success('修复文物修改成功')
              } else {
                this.$message.success('新增修复文物成功')
              }
              this.handleClose()
              this.getTableList()
            } else {
              this.$message.error(res.message)

            }
          }).catch(err => {
            this.loadingSave = false
          })
        }
      })
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 新增
    handleAdd() {
      this.operation = 'add'
      this.dialogVisible = true
    },

    fillFix(id) {
      this.$router.push({
        path: '/repair/repair-fill',
        query: { repairId: id }
      })
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },

    initCollectionList() {
      this.listLoading1 = true
      this.tableData1 = []
      this.$http.get('/collection/openCollections', {
        ...this.listQuery1,
        ...this.headParams
      })
        .then(res => {
          this.listLoading1 = false
          if (res.success) {
            this.tableData1 = res.result
            this.total1 = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 表格分页
    handleSizeChange1(val) {
      this.listQuery1.size = val
      this.initCollectionList()
    },
    // 点击序号
    handleCurrentChange1(val) {
      this.listQuery1.currentPage = val
      this.initCollectionList()
    },

  },
  created() {
    this.projectId = this.$route.query.projectId || ""
    this.initList()
    this.getDropdownValue()

    this.$on('getRowData', (row) => {
      console.log(row)
      this.$nextTick(() => {
        this.addForm.collectionName = row.collectName
        this.addForm.collectionNo = row.signCode
      })
    })
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-date-editor {
  width: 100%;
}
</style>